const $body = $('body')

class FilterPosts {

  constructor (block) {

    this.block = block
    this.filterData = {
      cat_id: block.attr('data-cat-id'),
      tag_id: 0,
      action: block.attr('data-filter-action')
    }

  }


  changeTag(tag_id) {

    const self = this

    self.filterData.tag_id = tag_id

    $.ajax({
      type: 'GET',
      url: localize_script.admin_ajax,
      data: {
        action: self.filterData.action,
        cat_id: self.filterData.cat_id,
        tag_id: self.filterData.tag_id
      },
      success: function (response) {
        console.log(response)
        self.block.html(response.html)
      }
    })

  }

}

class LoadMorePosts {

  constructor (block, button) {

    const self = this

    self.block = block
    self.button = button

    self.data = {
      action: 'load_more_posts',
      cat_id: parseInt(block.attr('data-cat-id')),
      tag_id: parseInt(block.attr('data-tag-id')),
      postsPerPage: parseInt(block.attr('data-per-page')),
      totalPosts: parseInt(block.attr('data-total-posts')),
      offset: parseInt(block.attr('data-offset')),
      page: 1
    }

    button.on('click', function (e){
      e.preventDefault()
      self.nextPage()
    })

  }

  nextPage() {

    const self = this

    $.ajax({
      type: 'GET',
      url: localize_script.admin_ajax,
      data: {
        action: self.data.action,
        cat_id: self.data.cat_id,
        tag_id: self.data.tag_id,
        post_per_page: self.data.postsPerPage,
        total_posts: self.data.totalPosts,
        offset: self.data.offset
      },
      success: function (response) {
        console.log(response)
        self.block.append(response.html)
        self.data.offset += self.data.postsPerPage

        if(self.data.offset >= self.data.totalPosts || self.data.postsPerPage < 0) {
          self.button.hide()
        }

      }
    })
  }

}

const tags = $('[data-filter-tag]')
const default_tag = $('[data-filter-tag="0"]')
const tags_active_btn = 'c-btn-active'
const postFilter = new FilterPosts($('#category-view'))

$body.on('click', '[data-filter-tag]', function (e) {
  e.preventDefault()

  const btn = $(this).hasClass(tags_active_btn) ? default_tag : $(this)

  postFilter.changeTag(btn.attr('data-filter-tag'))

  tags.removeClass('c-btn-active')
  btn.addClass('c-btn-active')

  $('[data-active-tag]').attr('data-active-tag', btn.attr('data-filter-tag'))

})

const loadMore = new LoadMorePosts($('#category-post-cards-view'), $('#show-all-posts'))

